const allTestimonialElements = Array.from(document.querySelectorAll("[data-testimonial-id]"));
const allSkuImgs = Array.from(document.querySelectorAll(".user-testimonials-sku-img-wrapper [data-sku]"));
const allSkuText = Array.from(document.querySelectorAll(".user-testimonials-bottom-sku-text div"));

const testimonialsCount = [...new Set(allTestimonialElements.map(el => parseInt(el.dataset.testimonialId)))].length;

const prevBtn = document.getElementsByClassName("user-testimonials-prev-wrapper")[0];
const nextBtn = document.getElementsByClassName("user-testimonials-next-wrapper")[0];

let crtTestimonialIdx = 0;

updateTestimonial(false);

prevBtn.addEventListener("click", prevTestimonial);
nextBtn.addEventListener("click", nextTestimonial);

function prevTestimonial(){
  crtTestimonialIdx = crtTestimonialIdx - 1;
  //Wrap around if at first testimonial
  if ( crtTestimonialIdx < 0) crtTestimonialIdx = testimonialsCount - 1;

  updateTestimonial(true);
}

function nextTestimonial(){
  crtTestimonialIdx = crtTestimonialIdx + 1;
  //Wrap around if at first testimonial
  if ( crtTestimonialIdx >= testimonialsCount) crtTestimonialIdx = 0;

  updateTestimonial(true);
}

function updateTestimonial(animate = true, testimonialIdx = crtTestimonialIdx){
  const selectedEl = allTestimonialElements.find(el => el.dataset.testimonialId == testimonialIdx);
  const testimonialSku = selectedEl.dataset.sku;

  //It's assumed that all elements will have the same transition speed
  const elTransDur = parseFloat(window.getComputedStyle(selectedEl).transitionDuration) * 1000;
  
  if (animate){
    allTestimonialElements.forEach(el => {
      const id = parseInt(el.dataset.testimonialId);
      if (id == testimonialIdx){
        setTimeout(() => {
          el.classList.remove("d-none");
          //Waiting one animation frame so the display none is removed and the opacity transition can play
          window.requestAnimationFrame(() => el.classList.remove("opacity-0"));
        }, elTransDur)
      }
      else{
        el.classList.add("opacity-0");
        setTimeout(() => {
           el.classList.add("d-none");
        }, elTransDur)
      }
    });
    allSkuImgs.forEach(img => {
      if (img.dataset.sku == testimonialSku){
        setTimeout(() => {
          img.classList.remove("d-none");
          //Waiting one animation frame so the display none is removed and the opacity transition can play
          window.requestAnimationFrame(() => img.classList.remove("opacity-0"));
        }, elTransDur)
      }
      else{
        img.classList.add("opacity-0");
        setTimeout(() => {
           img.classList.add("d-none");
        }, elTransDur)
      }
    });
    allSkuText.forEach(div => {
      if (div.dataset.sku == testimonialSku){
        setTimeout(() => {
          div.classList.remove("d-none");
          //Waiting one animation frame so the display none is removed and the opacity transition can play
          window.requestAnimationFrame(() => div.classList.remove("opacity-0"));
        }, elTransDur)
      }
      else{
        div.classList.add("opacity-0");
        setTimeout(() => {
           div.classList.add("d-none");
        }, elTransDur)
      }
    });
  }
  else{
    allTestimonialElements.forEach(el => {
      const id = parseInt(el.dataset.testimonialId);
      if (id == testimonialIdx){
        el.classList.remove("d-none");
        el.classList.remove("opacity-0");
      }
      else{
        el.classList.add("d-none");
        el.classList.add("opacity-0");
      }
    });
    allSkuImgs.forEach(img => {
      if (img.dataset.sku == testimonialSku){
        img.classList.remove("d-none");
        img.classList.remove("opacity-0");
      }
      else{
        img.classList.add("d-none");
        img.classList.add("opacity-0");
      }
    });
    allSkuText.forEach(div => {
      if (div.dataset.sku == testimonialSku){
        div.classList.remove("d-none");
        div.classList.remove("opacity-0");
      }
      else{
        div.classList.add("d-none");
        div.classList.add("opacity-0");
      }
    });
  }
}